var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-touch',{staticClass:"wrapper",on:{"swiperight":_vm.swiperright}},[_c('div',{staticClass:"attachmentPreview"},[_c('van-nav-bar',{attrs:{"title":"附件预览","left-text":"合同详情","left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_c('section',[_c('iframe',{attrs:{"src":_vm.src,"frameborder":"0"}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }